import { render, staticRenderFns } from "./mypageHeader.vue?vue&type=template&id=279ace28"
import script from "./mypageHeader.vue?vue&type=script&lang=ts"
export * from "./mypageHeader.vue?vue&type=script&lang=ts"
import style0 from "./mypageHeader.vue?vue&type=style&index=0&id=279ace28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports